import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="dom"
export default class extends Controller {
  static targets = ['node'];
  static values = { nodeSelector: String };

  connect() {}

  remove() {
    this.nodes().forEach((node) => node.remove());
  }

  empty() {
    this.nodes().forEach((node) => node.replaceChildren());
  }

  replaceValue(event) {
    this.nodes().forEach((node) => {
      node.value = node.value.replace(
        new RegExp(event.params['regexp'], event.params['regexpFlags']),
        event.params['replaceBy'],
      );
    });
  }

  setAttribute(event) {
    this.nodes().forEach((node) =>
      node.setAttribute(event.params['attribute'], event.params['value']),
    );
  }

  removeAttribute(event) {
    this.nodes().forEach((node) =>
      node.removeAttribute(event.params['attribute']),
    );
  }

  setInnerText(event) {
    // Sometimes we want to set the text parameter with JavaScript programmatically. Then we can't
    // use event.params, because Stimulus seems to overwrite this. However, event.params is helpful
    // when we want to set the text parameter with a data-dom-text-param attribute.
    const paramsText = event.params && event.params['text'];
    const detailText = event.detail && event.detail['text'];

    this.nodes().forEach((node) => (node.innerText = paramsText || detailText));
  }

  nodes() {
    if (this.hasNodeSelectorValue) {
      return document.querySelectorAll(this.nodeSelectorValue);
    } else {
      return this.nodeTargets;
    }
  }
}
